<template>
    <div class="app-container">
        <div class="app-left">
            <div class="app-header">
                <div class="app-filter-wrapper">
                    <!-- <input class="filter-search-input" type="text" placeholder="Buscar..." /> -->
                </div>
                <button class="action-button active" @click="openRightPanel">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-list" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                    </svg>
                </button>
            </div>
            <div class="app-left-content">
                <router-view />
            </div>
        </div>

        <MenuComponent />

    </div>
</template>
<script setup>
import { onMounted } from 'vue';
import MenuComponent from '@/components/MenuComponent.vue';

// Métodos para abrir/cerrar el panel derecho
const openRightPanel = () => {
    document.querySelector(".app-right").classList.add("isOpen");
    document.querySelector(".app-left").classList.add("hide");
};
// Efecto para las animaciones
onMounted(() => {
    const listItems = document.querySelectorAll(".fadeIn");
    const appBoxes = document.querySelectorAll(".app-box");

    listItems.forEach((listItem, index) => {
        listItem.style.animationDelay = `${index * 0.2}s`;
    });

    appBoxes.forEach((appBox, index) => {
        appBox.style.animationDelay = `${index * 0.1}s`;
    });
});
</script>

<style src="../styles/mainLayout.css"></style>